import React from 'react';

import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { getPrivacyLink } from '../../constants/constants';
import { theme } from '../../theme';
import { useLoadedFromApp } from 'src/hooks/useLoadedFromApp';

const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
`;

const Icon = styled.svg`
  fill: none;
  stroke: white;
  stroke-width: 2px;
`;
// Hide checkbox visually but remain accessible to screen readers.
// Source: https://polished.js.org/docs/#hidevisually
const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

interface IStyledCheckbox {
  checked: boolean;
  error?: boolean;
}

const StyledCheckbox = styled.div<IStyledCheckbox>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 16px;
  height: 16px;
  background: ${(props: any) => (props.checked ? '#0A6CFF' : '#fff')};
  border-color: ${(props: any) => {
    if (!props.checked && props.error) {
      return '#F01C4F';
    }

    return props.checked ? 'transparent' : '#464F6029';
  }};
  border-style: solid;
  border-width: 1px;
  border-radius: 4px;

  ${Icon} {
    visibility: ${props => (props.checked ? 'visible' : 'hidden')};
  }
`;

interface Props extends IStyledCheckbox {
  disabled: boolean;
  text: string;
  errorText?: string;
  onChange: () => void;
}

const StyledLegalText = styled.div`
  padding-left: 8;
  flex-grow: 1;

  > a {
    display: inline;
    text-decoration: underline;
    color: #4b4f55;
  }
`;

export const ConsentCheckBox = (props: Props) => {
  const { t } = useTranslation();

  const isLoadedFromApp = useLoadedFromApp();

  return (
    <>
      <label style={{ display: 'flex', cursor: 'pointer', gap: 8 }}>
        <CheckboxContainer className={'checkbox'}>
          <HiddenCheckbox
            disabled={props.disabled}
            checked={props.checked}
            onChange={props.onChange}
          />
          <StyledCheckbox checked={props.checked} error={props.error}>
            <svg
              width="10"
              height="8"
              viewBox="0 0 10 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.57814 5.26386L8.66634 1.41168e-05L9.66634 0.964046L3.57814 7.44179L0.333008 3.98902L1.33301 2.77512L3.57814 5.26386Z"
                fill={props.checked ? 'white' : 'transparent'}
              />
            </svg>
          </StyledCheckbox>
        </CheckboxContainer>
        <StyledLegalText
          dangerouslySetInnerHTML={{
            __html: props.text
          }}
        ></StyledLegalText>
      </label>

      {!!props.errorText && props.error && !props.checked ? (
        <div style={{ marginTop: 4 }}>
          <span style={{ color: theme.red }}>{props.errorText}</span>
        </div>
      ) : (
        <div style={{ marginTop: 4 }}>
          <span>&nbsp;</span>
        </div>
      )}
    </>
  );
};
